import React, { useEffect, useState } from 'react';
import { LoadingPage } from '../../pages/LoadingPage/LoadingPage';

type Props<T extends object> = {
  children: (
    data: {
      [key in keyof T]: T[key];
    }
  ) => JSX.Element | null;
  resolve?: () => {
    [key in keyof T]: Promise<T[key]>;
  };
  title: string;
  showCSVImport?: boolean;
};

export const Page = <T extends object>({
  children,
  resolve,
}: Props<T>): ReturnType<React.FC> => {
  type Data = Parameters<typeof children>[0];

  const [data, setData] = useState<Data>();
  const [loading, setLoading] = useState(false);

  const loadData: () => void = React.useCallback(() => {
    if (resolve) {
      setLoading(true);

      const entries = Object.entries<Promise<unknown>>(resolve());
      const promises = entries.map(([, promise]) => promise);

      Promise.all(promises)
        .then((values) => {
          const keys = entries.map(([key]) => key);
          const data = keys.reduce(
            (data, key, index) => ({ ...data, [key]: values[index] }),
            {} as Data
          );
          setData(data);
        })
        .finally(() => setLoading(false));
    }
  }, [resolve]);

  useEffect(loadData, [loadData]);

  const error = resolve && data === undefined;

  return (
    <section key={0} id="page">
      {loading ? (
        <div id="content">
          <LoadingPage />
        </div>
      ) : error ? (
        <div id="content">

        </div>
      ) : (
        [<>{children(data as Data)}</>]
      )}
    </section>
  );
};
